<template>
  <ReassuranceItem>
    <template #icon>
      <IconQuality />
    </template>
    <template #content>
      <button
        class="body-2 flex w-full items-center justify-between text-left"
        @click="openReassuranceModal"
      >
        <div>
          {{ i18n(translations.freeReturn, { day: coolingOffDays }) }}
          <span v-if="warrantyDelay">
            <br />
            {{ warrantyDelay }}
          </span>
        </div>

        <IconChevronRight />
      </button>
      <ReassuranceModal />
    </template>
  </ReassuranceItem>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { openModal } from '@ds/components/ModalBase'
import { IconChevronRight } from '@ds/icons/IconChevronRight'
import { IconQuality } from '@ds/icons/IconQuality'

import ReassuranceModal from '~/scopes/product/components/ReassuranceItems/components/ReassuranceModal/ReassuranceModal.vue'
import { MODAL_NAMES } from '~/scopes/product/constants'

import ReassuranceItem from '../ReassuranceItem/ReassuranceItem.vue'

import translations from './ItemReassurance.translations'

const props = withDefaults(
  defineProps<{
    warrantyDelay?: string | null
    tracking: Record<string, string>
  }>(),
  { warrantyDelay: '' },
)

const i18n = useI18n()
const { trackClick } = useTracking()
const { features } = useMarketplace()
const { coolingOffDays } = features

function openReassuranceModal(event: MouseEvent) {
  openModal(MODAL_NAMES.REASSURANCE, event)
  trackClick(props.tracking)
}
</script>
